import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import SearchBar from "@/components/site/SearchBar";
import PropertyCard from "@/components/site/PropertyCard";
import Seo from "@/components/site/Seo";

const SORTS = [["recent", "Más recientes"], ["price_asc", "Precio: menor a mayor"], ["price_desc", "Precio: mayor a menor"], ["bedrooms", "Más habitaciones"]];

export default function Catalog() {
  const [sp, setSp] = useSearchParams();
  const [data, setData] = useState({ items: [], total: 0, pages: 1 });
  const [loading, setLoading] = useState(true);
  const params = Object.fromEntries(sp.entries());
  const page = Number(params.page || 1);
  const key = sp.toString();

  useEffect(() => {
    setLoading(true);
    api.get("/public/properties", { params: { ...Object.fromEntries(new URLSearchParams(key).entries()), limit: 12 } })
      .then((r) => setData(r.data)).finally(() => setLoading(false));
  }, [key]);

  const setParam = (k, v) => {
    const n = new URLSearchParams(sp);
    v ? n.set(k, v) : n.delete(k);
    if (k !== "page") n.delete("page");
    setSp(n);
  };

  return (
    <div className="container-x py-12 space-y-10" data-testid="catalog-page">
      <Seo title={`Propiedades en alquiler${params.zone ? ` en ${params.zone}` : " en Punta Cana"}`} description="Catálogo de apartamentos, villas, casas y penthouses en alquiler de largo plazo en Punta Cana." />
      <div className="space-y-3">
        <p className="eyebrow">Catálogo</p>
        <h1 className="text-3xl sm:text-4xl font-extrabold">Propiedades en alquiler {params.zone ? `en ${params.zone}` : "en Punta Cana"}</h1>
      </div>
      <SearchBar key={key} initial={params} compact />
      <div className="flex flex-wrap items-center justify-between gap-4">
        <p className="text-sm text-slate-600" data-testid="catalog-total">{data.total} propiedades encontradas</p>
        <select value={params.sort || "recent"} onChange={(e) => setParam("sort", e.target.value)} className="h-10 rounded-full border border-slate-200 bg-white px-4 text-sm" data-testid="catalog-sort-select">
          {SORTS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
      </div>
      {loading ? <p className="text-slate-500">Cargando...</p> : (
        <div className="grid gap-7 sm:grid-cols-2 lg:grid-cols-3" data-testid="catalog-grid">{data.items.map((p) => <PropertyCard key={p.code} p={p} />)}</div>
      )}
      {!loading && !data.items.length && <p className="text-slate-500 py-12 text-center" data-testid="catalog-empty">No hay propiedades con estos filtros. Prueba ampliando tu búsqueda.</p>}
      {data.pages > 1 && (
        <div className="flex justify-center gap-2" data-testid="catalog-pagination">
          {Array.from({ length: data.pages }, (_, i) => i + 1).map((n) => (
            <button key={n} onClick={() => setParam("page", n)} className={`h-10 w-10 rounded-full text-sm font-semibold ${n === page ? "bg-slate-900 text-white" : "bg-white border border-slate-200"}`} data-testid={`catalog-page-${n}`}>{n}</button>
          ))}
        </div>
      )}
    </div>
  );
}
